import {createContext} from "react";

const EnableLoadingStateContext = createContext<Function>(() => {
    console.log('Warning: A component uses the EnableLoadingStateContext but no Provider is providing a value.')
})

export default EnableLoadingStateContext